import { Markierung } from '@/domain/termine/components';
import { MitarbeiterSchichtenPopover } from '@/domain/termine/features/Calendar/shared/TerminInfo/Verknuepfungen/MitarbeiterSchichtenPopover';
import { markierungMapper } from '@/domain/termine/shared/types';
import { Schichten } from '@/domain/termine/shared/types/Schichten';
import { formatArbeitszeitTimeRange } from '@/domain/termine/shared/utils/formatDateTime';
import dayjs from 'dayjs';

export function SchichtInfo({ schicht }: { schicht: Schichten }) {
  function formatDate(date?: dayjs.Dayjs) {
    if (!date) return '';
    return date.locale('de').format('dd., D. MMMM YYYY');
  }
  return (
    <div className="flex w-full">
      <div
        key={schicht.id}
        className="flex w-full items-center justify-between">
        <div className="flex flex-col">
          <span className="text-neutrals-900 text-sm">{schicht.name}</span>
          <div className="flex justify-between">
            <div className="flex items-center gap-1 text-xs font-normal text-neutrals-700">
              {schicht.markierung && (
                <Markierung color={markierungMapper[schicht.markierung].base} />
              )}
              {schicht.arbeitsbereich.name} ⋅{' '}
              {[
                formatDate(dayjs(schicht.datum)),
                formatArbeitszeitTimeRange(schicht.beginn, schicht.ende),
              ].join(', ')}
            </div>
          </div>
        </div>
        <MitarbeiterSchichtenPopover mitarbeiterListe={schicht.mitarbeiter} />
      </div>
    </div>
  );
}
